import { ViewOption } from "../../types/workspace";

export const VIEW_OPTION_NAME = {
  [ViewOption.COMPANY_LIST]: "Company List",
  [ViewOption.COMPETITIVE_ANALYSIS]: "Competitive Analysis",
  [ViewOption.MARKET_LANDSCAPE]: "Market Landscape",
};
